import { useSyncExternalStore } from 'react';

// Below 900 px the open drawer is always full view (no side mode to resize or toggle).
const NARROW_QUERY = '(max-width: 899px)';

const narrowMediaQuery = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(NARROW_QUERY)
    : undefined;

const subscribeNarrow = (onChange: () => void) => {
  const query = narrowMediaQuery();
  query?.addEventListener('change', onChange);
  return () => query?.removeEventListener('change', onChange);
};

/** True while the viewport is under 900 px; false where `matchMedia` is unavailable. */
export function useNarrowViewport(): boolean {
  return useSyncExternalStore(subscribeNarrow, () => narrowMediaQuery()?.matches ?? false);
}

const subscribeResize = (onChange: () => void) => {
  window.addEventListener('resize', onChange);
  return () => window.removeEventListener('resize', onChange);
};

/** `window.innerWidth`, re-read on every resize so the drawer's width cap follows the window. */
export function useViewportWidth(): number {
  return useSyncExternalStore(subscribeResize, () => window.innerWidth);
}
